import React from 'react';
import {Button, Card, Stack, SvgIcon, Typography, Box, Container, useMediaQuery} from "@mui/material";
import Upload01Icon from "@untitled-ui/icons-react/build/esm/Upload01";
import Download01Icon from "@untitled-ui/icons-react/build/esm/Download01";
import PlusIcon from "@untitled-ui/icons-react/build/esm/Plus";
import localStrings from "../../localStrings";
import {Seo} from "../seo";

function PageWithTitle({title, mainButtons, actionButtons, children}) {
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  return (
    <>
      <Seo title={title} />

      <Container maxWidth="xl" sx={{margin: '2px', padding: 0}}>
        <Stack spacing={0}>
          <Stack
            direction="row"
            justifyContent="space-between"
            spacing={0}
          >
            <Stack spacing={1}>
              <Typography variant="h6">
                {title}
              </Typography>
              {actionButtons &&
                <Stack
                  alignItems="center"
                  direction="row"
                  spacing={1}
                >

                  {actionButtons}
                </Stack>
              }
            </Stack>
            <Stack
              alignItems="center"
              direction="row"
              spacing={3}
            >
              {mainButtons}
            </Stack>
          </Stack>
          {/*<Card>*/}
          {children}
          {/*</Card>*/}
        </Stack>
        <Stack height={100}/>
      </Container>
    </>
    // </Box>
  );
}

export default PageWithTitle;
